import { useState, useEffect, useMemo } from "react";

// Material UI components
import Grid from "@mui/material/Grid";

// Formik components
import FormSelect from "components/FormSelect";
import FormField from "components/FormField";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Page components

// Contexts

function ExportProjectionsForm({ formData }: { formData: any }): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { country, startPeriodYear, lastPeriodYear, periodYearStep } = formField;

  return (
    <MDBox sx={{ marginTop: 2, marginBottom: 2 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h6">Country:</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormSelect
            label={country.label}
            name={country.name}
            options={country.options}
            value={values.locCode}
            error={errors.locCode && touched.locCode}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h6">Starting Year:</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormField
            disabled={true}
            formatted={false}
            label={startPeriodYear.label}
            name={startPeriodYear.name}
            options={startPeriodYear.options}
            value={values.startPeriodYear}
            error={errors.startPeriodYear && touched.startPeriodYear}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h6">Last Year:</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormSelect
            label={lastPeriodYear.label}
            name={lastPeriodYear.name}
            options={lastPeriodYear.options}
            value={values.lastPeriodYear}
            error={errors.lastPeriodYear && touched.lastPeriodYear}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h6">Period coverage (years):</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormSelect
            label={periodYearStep.label}
            name={periodYearStep.name}
            options={periodYearStep.options}
            value={values.periodYearStep}
            error={errors.periodYearStep && touched.periodYearStep}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default ExportProjectionsForm;
